import React from "react";
import { Menu } from "antd";

import { Link } from "../styles/Design";

const DropDownMenu = () => (
  <Menu>
    <Menu.Item key="0">
      <Link to="/profile">الصفحة الشخصية</Link>
    </Menu.Item>
    <Menu.Item key="1">
      <a href="https://www.aliyun.com">2nd menu item</a>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item
      key="3"
      onClick={() => {
        localStorage.removeItem("user");

        window.location.reload();
      }}
    >
      تسجيل الخروج
    </Menu.Item>
  </Menu>
);

export default DropDownMenu;
